export const bidiotvMoviesTh=[
    {
        id: 1,
        contents: 10,
        name: {
          th:'ผจญภัย'
        },
        videos: [
          {
            duration: "Watch Now",
            id: 100,
            name: "โอกาสครั้งหนึ่งในชีวิต: ล่องแพน้ำแข็งไซบีเรียที่ไม่เหมือนใคร 100%",
            videoUrl: "https://cdn.mobiotv.com/th/Adventure/Bucket+list+opportunity-+Siberian+ice+rafting+is+100%25+unique.mp4",
            desc: "",
            preview: "https://cdn.mobiotv.com/th/Adventure/Bucket+list+opportunity-+Siberian+ice+rafting+is+100%25+unique.jpg",
            filename: "",
          },
          {
            duration: "Watch Now",
            id: 102,
            name: "มูเนียโยส หนึ่งในผืนป่าที่เข้าถึงยากที่สุดในโลก",
            videoUrl: "https://cdn.mobiotv.com/th/Adventure/Muniellos+One+of+the+most+exclusive+forests+in+the+world.mp4",
            desc: "",
            preview: "https://cdn.mobiotv.com/th/Adventure/Muniellos+One+of+the+most+exclusive+forests+in+the+world.jpg",
            filename: "",
          },
          {
            duration: "Watch Now",
            id: 103,
            name: "คุณยายวัย 85 ปีคนนี้เล่นเกมเก่งกว่าคนที่อายุเพียงครึ่งหนึ่ง",
            videoUrl: "https://cdn.mobiotv.com/th/Adventure/This+85-year-old+grandma+games+harder+than+people+half+her+age.mp4",
            desc: "",
            preview: "https://cdn.mobiotv.com/th/Adventure/This+85-year-old+grandma+games+harder+than+people+half+her+age.jpg",
            filename: "",
          },
          {
            duration: "Watch Now",
            id: 104,
            name: "จักรยานไฟฟ้าคันนี้ให้คุณปั่นบนผิวน้ำได้",
            videoUrl: "https://cdn.mobiotv.com/th/Adventure/With+this+e-bike%2C+you+can+cycle+on+water.mp4",
            desc: "",
            preview: "https://cdn.mobiotv.com/th/Adventure/With+this+e-bike%2C+you+can+cycle+on+water.jpg",
            filename: "",
          },
          {
            duration: "Watch Now",
            id: 105,
            name: "ผลการสืบสวนอันน่าทึ่งหลังเรือไททานิกล่ม",
            videoUrl: "https://cdn.mobiotv.com/th/Adventure/The+fascinating+investigation+findings+after+the+Titanic+sank.mp4",
            desc: "",
            preview: "https://cdn.mobiotv.com/th/Adventure/The+fascinating+investigation+findings+after+the+Titanic+sank.jpg",
            filename: "",
          },
        ]
    },
    {
        id: 2,
        contents: 10,
        name: {
          th:'ทำอาหาร'
        },
        videos: [
          {
            duration: "Watch Now",
            id: 200,
            name: "ทุกเมนูที่จีจี้และเบลลา ฮาดิดทำในช่วงกักตัว",
            videoUrl: "https://cdn.mobiotv.com/th/Cooking/All+the+recipes+Gigi+%26+Bella+Hadid+have+cooked+in+quarantine.mp4",
            desc: "",
            preview: "https://cdn.mobiotv.com/th/Cooking/All+the+recipes+Gigi+%26+Bella+Hadid+have+cooked+in+quarantine.jpg",
            filename: "",
          },
          {
            duration: "Watch Now",
            id: 201,
            name: "อยากกินของหวานใช่ไหม ลองทำพุดดิ้งเชคสายรุ้งนี้",
            videoUrl: "https://cdn.mobiotv.com/th/Cooking/Craving+someothing+sweet+Try+making+this+rainbow+pudding+shake.mp4",
            desc: "",
            preview: "https://cdn.mobiotv.com/th/Cooking/Craving+someothing+sweet+Try+making+this+rainbow+pudding+shake.jpg",
            filename: "",
          },
          {
            duration: "Watch Now",
            id: 202,
            name: "อยากกินของหวานใช่ไหม ลองทำมิลค์เชคชูการ์บอมบ์",
            videoUrl: "https://cdn.mobiotv.com/th/Cooking/Craving+something+sweet+Make+a+'Sugar+Bomb'+milkshake.mp4",
            desc: "",
            preview: "https://cdn.mobiotv.com/th/Cooking/Craving+something+sweet+Make+a+'Sugar+Bomb'+milkshake.jpg",
            filename: "",
          },
          {
            duration: "Watch Now",
            id: 203,
            name: "อยากกินของหวานใช่ไหม ลองทำมิลค์เชคสตรอว์เบอร์รีนี้",
            videoUrl: "https://cdn.mobiotv.com/th/Cooking/Craving+something+sweet+Try+making+this+strawberry+milkshake.mp4",
            desc: "",
            preview: "https://cdn.mobiotv.com/th/Cooking/Craving+something+sweet+Try+making+this+strawberry+milkshake.jpg",
            filename: "",
          },
          {
            duration: "Watch Now",
            id: 204,
            name: "อยากกินของหวานใช่ไหม ลองทำมิลค์เชคโอรีโอแสนอร่อยนี้!",
            videoUrl: "https://cdn.mobiotv.com/th/Cooking/Craving+something+sweet+Try+making+this+yummy+Oreo+milkshake!.mp4",
            desc: "",
            preview: "https://cdn.mobiotv.com/th/Cooking/Craving+something+sweet+Try+making+this+yummy+Oreo+milkshake!.jpg",
            filename: "",
          },
        ]
    },
    {
      id: 3,
      contents: 10,
      name: {
        th:'ฮอลลีวูด'
      },
      videos: [
        {
          duration: "Watch Now",
          id: 300,
          name: "นอกจาก Ariana Grande แล้ว นี่คือ 5 ศิลปินที่ Victoria Monét แต่งเพลงให้",
          videoUrl: "https://cdn.mobiotv.com/th/Hollywood/Besides+Ariana+Grande%2C+here+are+5+stars+Victoria+Mone't+wrote+music+for.mp4",
          desc: "",
          preview: "https://cdn.mobiotv.com/th/Hollywood/Besides+Ariana+Grande%2C+here+are+5+stars+Victoria+Mone't+wrote+music+for.jpg",
          filename: "",
        },
        {
          duration: "Watch Now",
          id: 301,
          name: "5 เรื่องน่าทึ่งเกี่ยวกับชีวิตของ David Attenborough",
          videoUrl: "https://cdn.mobiotv.com/th/Hollywood/Five+Fascinating+facts+about+David+Attenborough's+life.mp4",
          desc: "",
          preview: "https://cdn.mobiotv.com/th/Hollywood/Five+Fascinating+facts+about+David+Attenborough's+life.jpg",
          filename: "",
        },
        {
          duration: "Watch Now",
          id: 302,
          name: "เพลงป๊อปทรงพลังจาก Demi Lovato, Sam Smith และ Kelly Rowland",
          videoUrl: "https://cdn.mobiotv.com/th/Hollywood/Power+pop+from+Demi+Lovato%2C+Sam+Smith+and+even+Kelly+Rowland.mp4",
          desc: "",
          preview: "https://cdn.mobiotv.com/th/Hollywood/Power+pop+from+Demi+Lovato%2C+Sam+Smith+and+even+Kelly+Rowland.jpg",
          filename: "",
        },
        {
          duration: "Watch Now",
          id: 303,
          name: "มือกีตาร์ระดับตำนานของ Queen พร้อมเทศนาเรื่องวีแกน",
          videoUrl: "https://cdn.mobiotv.com/th/Hollywood/Queen's+legendary+guitarist+is+ready+to+get+'preachy'+about+veganism.mp4",
          desc: "",
          preview: "https://cdn.mobiotv.com/th/Hollywood/Queen's+legendary+guitarist+is+ready+to+get+'preachy'+about+veganism.jpg",
          filename: "",
        },
        {
          duration: "Watch Now",
          id: 304,
          name: "ฮอลลีวูดหลงเสน่ห์พัคโซดัม ดาวเด่นจาก Parasite ได้อย่างไร",
          videoUrl: "https://cdn.mobiotv.com/th/Hollywood/How+Hollywood+got+bit+by+'Parasite'+star+Park+So-Dam.mp4",
          desc: "",
          preview: "https://cdn.mobiotv.com/th/Hollywood/How+Hollywood+got+bit+by+'Parasite'+star+Park+So-Dam.jpg",
          filename: "",
        },
        {
          duration: "Watch Now",
          id: 305,
          name: "3 เรื่องที่ James Gunn บอกแฟน ๆ Guardians of the Galaxy ระหว่างปาร์ตี้ชมภาพยนตร์",
          videoUrl: "https://cdn.mobiotv.com/th/Hollywood/3+things+James+Gunn+told+%60GotG_+fans+during+his+watch+party.mp4",
          desc: "",
          preview: "https://cdn.mobiotv.com/th/Hollywood/3+things+James+Gunn+told+%60GotG_+fans+during+his+watch+party.jpg",
          filename: "",
        },
        {
          duration: "Watch Now",
          id: 306,
          name: "5 ครั้งที่ Elle Fanning เป็นเจ้าหญิงแห่งพรมแดงอย่างแท้จริง",
          videoUrl: "https://cdn.mobiotv.com/th/Hollywood/5+Times+Elle+Fanning+was+a+total+red+carpet+princess.mp4",
          desc: "",
          preview: "https://cdn.mobiotv.com/th/Hollywood/5+Times+Elle+Fanning+was+a+total+red+carpet+princess.jpg",
          filename: "",
        },
        {
          duration: "Watch Now",
          id: 307,
          name: "รวมภาพย้อนวันวานของ Victoria Beckham ในบท Posh Spice",
          videoUrl: "https://cdn.mobiotv.com/th/Hollywood/All+the+FBF+you+need+of+Victoria+Beckham+as+Posh+Spice.mp4",
          desc: "",
          preview: "https://cdn.mobiotv.com/th/Hollywood/All+the+FBF+you+need+of+Victoria+Beckham+as+Posh+Spice.jpg",
          filename: "",
        },
        {
          duration: "Watch Now",
          id: 308,
          name: "ทุกลุคพรมแดงสุดปังของ Anya Taylor-Joy",
          videoUrl: "https://cdn.mobiotv.com/th/Hollywood/All+the+red+carpets+Anya+Taylor-Joy+came+to+slay.mp4",
          desc: "",
          preview: "https://cdn.mobiotv.com/th/Hollywood/All+the+red+carpets+Anya+Taylor-Joy+came+to+slay.jpg",
          filename: "",
        },
        {
          duration: "Watch Now",
          id: 309,
          name: "แฟน Black Widow ในสหราชอาณาจักรดีใจกับวันฉายที่เร็วขึ้น",
          videoUrl: "https://cdn.mobiotv.com/th/Hollywood/Black+Widow+fans+in+the+UK+rejoicing+over+earlier+release+date.mp4",
          desc: "",
          preview: "https://cdn.mobiotv.com/th/Hollywood/Black+Widow+fans+in+the+UK+rejoicing+over+earlier+release+date.jpg",
          filename: "",
        },
        {
          duration: "Watch Now",
          id: 310,
          name: "Cynthia Rowley ให้กำเนิด Blair Waldorf แห่ง Gen Z",
          videoUrl: "https://cdn.mobiotv.com/th/Hollywood/Cynthia+Rowley+gave+birth+to+a+Gen-Z+Blair+Waldorf.mp4",
          desc: "",
          preview: "https://cdn.mobiotv.com/th/Hollywood/Cynthia+Rowley+gave+birth+to+a+Gen-Z+Blair+Waldorf.jpg",
          filename: "",
        },
        {
          duration: "Watch Now",
          id: 311,
          name: "มีรายงานว่า Disney กำลังเจรจาเพื่อนำ Black Widow ลงสตรีมมิงโดยตรง",
          videoUrl: "https://cdn.mobiotv.com/th/Hollywood/Disney+reportedly+in+talks+to+release+_Black+Widow_+straight+to+streaming.mp4",
          desc: "",
          preview: "https://cdn.mobiotv.com/th/Hollywood/Disney+reportedly+in+talks+to+release+_Black+Widow_+straight+to+streaming.jpg",
          filename: "",
        },
      ]
    },
    {
      id: 4,
      contents: 10,
      name: {
        en:'กีฬาและเกม'
      },
      videos: [
        {
          duration: "Watch Now",
          id: 400,
          name: "อีสปอร์ต: อุตสาหกรรมนี้ช่วยกอบกู้เศรษฐกิจของประเทศได้หรือไม่",
          videoUrl: "https://cdn.mobiotv.com/th/Sports+%26+Gaming/Esports+-+Can+the+industry+save+a+country's+economy.mp4",
          desc: "",
          preview: "https://cdn.mobiotv.com/th/Sports+%26+Gaming/Esports+-+Can+the+industry+save+a+country's+economy.jpg",
          filename: "",
        },
        {
          duration: "Watch Now",
          id: 401,
          name: "ข่าวอีสปอร์ต: LDLC, Rocket League, BBC และอีกมากมาย",
          videoUrl: "https://cdn.mobiotv.com/th/Sports+%26+Gaming/Esports+news+LDLC%2C+Rocket+League%2C+BBC+and+more.mp4",
          desc: "",
          preview: "https://cdn.mobiotv.com/th/Sports+%26+Gaming/Esports+news+LDLC%2C+Rocket+League%2C+BBC+and+more.jpg",
          filename: "",
        },
        {
          duration: "Watch Now",
          id: 402,
          name: "ข่าวอีสปอร์ต: ผู้ชนะ LEC, TSM, FPX และอีกมากมาย",
          videoUrl: "https://cdn.mobiotv.com/th/Sports+%26+Gaming/Esports+news+LEC+Winners%2C+TSM%2C+FPX+and+more.mp4",
          desc: "",
          preview: "https://cdn.mobiotv.com/th/Sports+%26+Gaming/Esports+news+LEC+Winners%2C+TSM%2C+FPX+and+more.jpg",
          filename: "",
        },
        {
          duration: "Watch Now",
          id: 403,
          name: "ข่าวอีสปอร์ต: Pokémon, ESL One, อีเวนต์ยอดนิยม และอีกมากมาย",
          videoUrl: "https://cdn.mobiotv.com/th/Sports+%26+Gaming/Esports+news+Poke'mon%2C+ESL+One%2C+Popular+events+and+more.mp4",
          desc: "",
          preview: "https://cdn.mobiotv.com/th/Sports+%26+Gaming/Esports+news+Poke'mon%2C+ESL+One%2C+Popular+events+and+more.jpg",
          filename: "",
        },
        {
          duration: "Watch Now",
          id: 404,
          name: "ข่าวอีสปอร์ต: DreamHack, Twitch, Sinatraa และอีกมากมาย",
          videoUrl: "https://cdn.mobiotv.com/th/Sports+%26+Gaming/Esports+news+Dreamhack%2C+Twitch%2C+Sinatraa+and+more.mp4",
          desc: "",
          preview: "https://cdn.mobiotv.com/th/Sports+%26+Gaming/Esports+news+Dreamhack%2C+Twitch%2C+Sinatraa+and+more.jpg",
          filename: "",
        },
        {
          duration: "Watch Now",
          id: 405,
          name: "อัปเดตวงการเกม: EVO, Summer Game Fest, GDC และอีกมากมาย",
          videoUrl: "https://cdn.mobiotv.com/th/Sports+%26+Gaming/Gaming+Industry+Updates+EVO%2C+Summer+Game+Fest%2C+GDC+and+more.mp4",
          desc: "",
          preview: "https://cdn.mobiotv.com/th/Sports+%26+Gaming/Gaming+Industry+Updates+EVO%2C+Summer+Game+Fest%2C+GDC+and+more.jpg",
          filename: "",
        },
        {
          duration: "Watch Now",
          id: 406,
          name: "อัปเดตวงการเกม: เยอรมนี, Travis Scott, LoL MSI และอีกมากมาย",
          videoUrl: "https://cdn.mobiotv.com/th/Sports+%26+Gaming/Gaming+Industry+Updates+Germany%2C+Travis+Scott%2C+LoL+MSI+and+more.mp4",
          desc: "",
          preview: "https://cdn.mobiotv.com/th/Sports+%26+Gaming/Gaming+Industry+Updates+Germany%2C+Travis+Scott%2C+LoL+MSI+and+more.jpg",
          filename: "",
        },
        {
          duration: "Watch Now",
          id: 407,
          name: "อัปเดตวงการเกม: Ubisoft, Switch, Capcom และอีกมากมาย",
          videoUrl: "https://cdn.mobiotv.com/th/Sports+%26+Gaming/Gaming+Industry+Updates+Ubisoft%2C+Switch%2C+Capcom+and+more.mp4",
          desc: "",
          preview: "https://cdn.mobiotv.com/th/Sports+%26+Gaming/Gaming+Industry+Updates+Ubisoft%2C+Switch%2C+Capcom+and+more.jpg",
          filename: "",
        }
      ]
    },
]



// WEBPACK FOOTER //
// ./src/constants/bidiotvmovies_th.js